import { DatafieldType, FieldDefinitionTypes } from "@/shared/services/graphql/generated/consumer-graph-types";

export interface DatafieldFragments {
    datafields: Record<string, string[]>;
    localizationDatafields: Record<string, string[]>;
}

export interface DisplayOptions {
    dateOptions?: "date" | "dateTime";
    showMobile?: boolean;
    symbolConfigurationEnabled?: boolean;
    symbolConfig?: Record<string, string>;
    symbolConfigLabel?: Record<string, Record<string, string>>;
    colorClass?: string;
}

export enum DataDisplayConfigId {
    productSelection = "product-selection",
    assetSelection = "asset-selection",
    parts = "parts",
    partDetails = "part-details",
    documentSelection = "document-selection",
    documentDetails = "document-details",
    product = "product",
    asset = "asset",
    article = "article",
    articleSelection = "article-selection",
    activitiesSelection = "activities-selection",
    documentGo = "document-go",
    documentVariants = "document-variants",
}

export interface DataDisplayField {
    key: string;
    title: string;
    fieldTypeInfo: {
        type: DatafieldType;
        fieldType: FieldDefinitionTypes;
        displayOptions?: DisplayOptions;
    };
    displayValues: Record<string, string>;
    isPriority: boolean;
    trueValue?: string;
    falseValue?: string;
}

export interface DataDisplayEntry {
    referencedId: string;
    fieldType: FieldDefinitionTypes;
}

/** The parts of a GraphQL result node the display helpers read; the datafields themselves are dynamic. */
export interface DisplayResultNode {
    teasers?: Record<string, unknown> | null;
    localizations?: Record<string, unknown> | null;
    useContext?: Record<string, unknown> | null;
    [datafield: string]: unknown;
}
